/**
 * Generator plików SVG dla eksportu rozkroju
 * SVG - uniwersalny format wektorowy
 */

import { CuttingLayout } from './sheetOptimizer';

export class SVGGenerator {
  /**
   * Generuje plik SVG z rozkroju
   */
  generateFromLayout(layout: CuttingLayout, scale: number = 0.2): string {
    const width = layout.sheet.width * scale;
    const height = layout.sheet.height * scale;
    
    let svg = `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" 
     xmlns:xlink="http://www.w3.org/1999/xlink"
     width="${width}mm" 
     height="${height}mm"
     viewBox="0 0 ${width} ${height}"
     version="1.1">
  
  <!-- PlexiSystem Cutting Layout -->
  <!-- Material: ${layout.sheet.material} ${layout.sheet.thickness}mm -->
  <!-- Sheet: ${layout.sheet.width}x${layout.sheet.height}mm -->
  <!-- Utilization: ${layout.utilization.toFixed(1)}% -->
  
  <defs>
    <style type="text/css">
      .sheet { fill: none; stroke: #0066cc; stroke-width: 2; }
      .cut { fill: rgba(255,0,0,0.1); stroke: #ff0000; stroke-width: 1; }
      .label { font-family: Arial; font-size: 12px; fill: #333; text-anchor: middle; }
      .dimension { font-family: Arial; font-size: 10px; fill: #666; }
    </style>
  </defs>
  
  <!-- Sheet outline -->
  <rect x="0" y="0" width="${width}" height="${height}" class="sheet"/>
  
  <!-- Cut pieces -->
  <g id="pieces">`;
    
    layout.placedPieces.forEach((piece, index) => {
      const x = piece.x * scale;
      const y = piece.y * scale;
      const w = piece.width * scale;
      const h = piece.height * scale;
      
      svg += `
    <!-- Piece ${index + 1}: ${piece.originalPiece.label || piece.id} -->
    <g id="piece_${index}">
      <rect x="${x}" y="${y}" width="${w}" height="${h}" class="cut"/>`;
      
      if (piece.originalPiece.label) {
        svg += `
      <text x="${x + w/2}" y="${y + h/2}" class="label">${piece.originalPiece.label}</text>`;
      }
      
      svg += `
      <text x="${x + w/2}" y="${y - 2}" class="dimension">${piece.width}mm</text>
      <text x="${x - 2}" y="${y + h/2}" class="dimension" transform="rotate(-90 ${x - 2} ${y + h/2})">${piece.height}mm</text>
    </g>`;
    });
    
    svg += `
  </g>
</svg>`;
    
    return svg;
  }
  
  /**
   * Generuje plik SVG z wieloma arkuszami
   */
  generateFromLayouts(layouts: CuttingLayout[], scale: number = 0.2): string {
    const spacing = 20;
    let totalWidth = 0;
    let maxHeight = 0;
    
    // Oblicz wymiary całkowite
    layouts.forEach(layout => {
      totalWidth += layout.sheet.width * scale + spacing;
      maxHeight = Math.max(maxHeight, layout.sheet.height * scale);
    });
    
    let svg = `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg"
     width="${totalWidth}mm"
     height="${maxHeight + 40}mm"
     viewBox="0 0 ${totalWidth} ${maxHeight + 40}"
     version="1.1">
  
  <defs>
    <style type="text/css">
      .sheet { fill: none; stroke: #0066cc; stroke-width: 2; }
      .cut { fill: rgba(255,0,0,0.1); stroke: #ff0000; stroke-width: 1; }
      .label { font-family: Arial; font-size: 12px; fill: #333; text-anchor: middle; }
      .title { font-family: Arial; font-size: 16px; font-weight: bold; fill: #000; text-anchor: middle; }
      .info { font-family: Arial; font-size: 10px; fill: #666; }
    </style>
  </defs>`;
    
    let offsetX = 0;
    
    layouts.forEach((layout, layoutIndex) => {
      const width = layout.sheet.width * scale;
      const height = layout.sheet.height * scale;
      
      svg += `
  
  <!-- Sheet ${layoutIndex + 1} -->
  <g id="sheet_${layoutIndex}" transform="translate(${offsetX}, 30)">
    <rect x="0" y="0" width="${width}" height="${height}" class="sheet"/>
    <text x="${width/2}" y="-10" class="title">Arkusz ${layoutIndex + 1}</text>
    <text x="${width/2}" y="${height + 15}" class="info">
      ${layout.sheet.material} ${layout.sheet.thickness}mm | 
      Wykorzystanie: ${layout.utilization.toFixed(1)}% |
      Elementów: ${layout.placedPieces.length}
    </text>`;
      
      layout.placedPieces.forEach((piece, pieceIndex) => {
        const x = piece.x * scale;
        const y = piece.y * scale;
        const w = piece.width * scale;
        const h = piece.height * scale;
        
        svg += `
    <rect x="${x}" y="${y}" width="${w}" height="${h}" class="cut"/>`;
        
        if (piece.originalPiece.label) {
          svg += `
    <text x="${x + w/2}" y="${y + h/2}" class="label">${piece.originalPiece.label}</text>`;
        }
      });
      
      svg += `
  </g>`;
      
      offsetX += width + spacing;
    });
    
    svg += `
</svg>`;
    
    return svg;
  }
}